export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13771.5a785e8a.jpg";